export enum Order
{
    Ascending = 'asc',
    Descending = 'desc',
}